import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { forkJoin, map, Observable } from 'rxjs';
import { ProjectService } from './project.service';
import { ClientService } from '../clients/clients.service';
import { RouteCacheService } from '../../shared/services/route-cache.service';

@Injectable({ providedIn: 'root' })
export class ProjectResolver implements Resolve<any> {
  constructor(private projectService: ProjectService) {}
  clientsSvc = inject(ClientService);
  routeCache = inject(RouteCacheService);

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (route.url.some((segment) => segment.path === 'add')) {
      return forkJoin({
        clients: this.clientsSvc.get(undefined, { page: 1, limit: 5 }),
      });
    }

    const id = route.paramMap.get('id');
    if (id) {
      if (route.url.some((segment) => segment.path === 'edit')) {
        return forkJoin({
          clients: this.clientsSvc.get(undefined, { page: 1, limit: 5 }),
          project: this.projectService.getProjectById(id),
        });
      }
      // For detail view, return the detailed project data
      return this.projectService.getProjectById(id);
    }
    const contextRoute = this.routeCache.getContextRoute(route);
    const gridState = contextRoute?.data?.gridProjectState;
    const filters = gridState?.filters ?? {};

    return this.projectService
      .get(undefined, {
        page:
          gridState?.paginator?.pageIndex != null
            ? gridState.paginator.pageIndex + 1
            : 1,
        limit: gridState?.paginator?.pageSize ?? 15,
        ...(filters.status ? { status: filters.status } : {}),
        ...(filters.clientId ? { clientId: filters.clientId } : {}),
      })
      .pipe(
        map((response) => ({
          ...response,
          data: response.data.map((item) => ({
            ...item,
          })),
        })),
      );
  }
}
